import { Component, HostListener, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from './shared/app-header/app-header.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AppHeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  // Vertikaler Versatz des Hintergrunds in px (immer <= 0, da er sich nur nach oben aus seiner
  // Top-Position heraus verschiebt).
  readonly bgOffset = signal(0);

  ngOnInit(): void {
    this.updateBgOffset();
  }

  @HostListener('window:scroll')
  @HostListener('window:resize')
  updateBgOffset(): void {
    const viewportHeight = window.innerHeight;
    const maxScrollTop = Math.max(0, document.documentElement.scrollHeight - viewportHeight);
    const progress = maxScrollTop > 0 ? window.scrollY / maxScrollTop : 0;

    // Bild ist quadratisch und volle Fensterbreite -> Bildhoehe == Fensterbreite.
    const imageHeight = window.innerWidth;
    const panRange = Math.max(0, imageHeight - viewportHeight);

    this.bgOffset.set(-progress * panRange);
  }
}
